export const styles = {
  thickDivider: {
    backgroundColor: 'gray.3',
    height: 8,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
  },
  resultsWrapper: {
    flexDirection: 'row',
    width: '100%',
    paddingTop: 2,
    marginBottom: 2,
    paddingX: 2,
  },
  avatarWrapper: {
    paddingTop: 1,
  },
  userInfo: ({ breakpoints }) => ({
    paddingLeft: 1.5,
    flexDirection: 'column',
    justifyContent: 'center',
    [breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  }),
  userOptions: ({ breakpoints }) => ({
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    [breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-start',
      marginTop: 2,
    },
  }),
  lastCheckin: {
    flexDirection: 'row',
    alignItems: 'center',
    width: 'auto',
  },
  divider: {
    borderColor: 'gray.8',
    marginX: 2,
  },
  userInfoWrapper: {
    marginBottom: 1,
  },
  timeAgo: {
    marginLeft: 0.5,
  },
  userWrapper: ({ breakpoints }) => ({
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      flex: 'wrap',
      paddingLeft: 2,
    },
  }),
  barcodeIcon: { color: 'gray.56', fontSize: 16, marginRight: 1 },
}
